/**
 *
 */
import {
  TREND_ONE,
  TREND_FIVE,
  KLINE_ONEMIN,
  KLINE_FIVEMIN,
  KLINE_FIFMIN,
  KLINE_THIMIN,
  KLINE_SIXMIN,
  KLINE_ONEDAY,
  KLINE_ONEWEEK,
  KLINE_ONEMONTH,
  KLINE_ONEYEAR,
  KEY_MAP,
} from '../viewmodel/setting.js';
import Util from '../util/index.js';
import {isValidNumber} from "../util";
/*
检查是否沪深
 */
export const checkSS = (code,type='s_c') => {
  let _data = [];
  const SSList = ['.SS', '.SZ',  '.XSHG', '.XSHE'];
  const SSComponent = ['.SH','.XBHS']
  const List = { 's':SSList,'c':SSComponent }
  const data = type.split('_').map(item=>item)
  data.forEach(d => {
    const last = List[d]
    _data = [..._data, ...last];
  });
  return _data.some(a => new RegExp(a +'$').test(code));
  // return SSList.some(a => new RegExp(a +'$').test(code));
}
/*
检查是否期权
 */
export const checkPower = (code) => {
  let _data = ['.SHO','.XSHO'];
  return _data.some(a => new RegExp(a).test(code));
}
/*
检查是否期货
 */
export const checkFutures = (code,type = 'en_ch_sh') => {
  let _data = [];
  //国内
  const chFurures = [ 'CFFE', 'CCFX', 'SHFE', 'XSGE', 'DCE', 'XDCE', 'CZCE', 'XZCE', 'SHGE', 'SGE' ];
  //国外
  const enFurures = [ 'XCBT', 'CBOT', 'XLME', 'LME', 'XNYM', 'NYMEX', 'XCEC', 'COMEX', 'CME', 'CMES', 'CBOTMINI', 'XCBM' ];
  //上海能源期货交易中心
  const shFurures = [ 'XINE','INE' ]
  const data = type.split('_').map(item=>item+'Furures')
  const fururesAll = { 'chFurures':chFurures,'enFurures':enFurures,'shFurures':shFurures }
  data.forEach(d => {
    const last = fururesAll[d]
    _data = [..._data, ...last];
  });
  return _data.some(a => new RegExp(a).test(code));
}
/*
检查是否美股
 */
export const checkAmerican = code => {
  const AmericanList = ['A', 'CBOT', 'COMEX', 'N', 'NYMEX', 'O', 'XBUS'];
  // return AmericanList.some(a => new RegExp('^[^\.]+?\.' + a).test(code));
  return AmericanList.some(a => new RegExp(a+'$').test(code));
}
/*
检查是否港股
 */
export const checkHKM = code => {
  const HKMList = ['HKM', 'XHKG-M', 'HKI', 'XHKG-I', 'HKG', 'XHKG-G', 'HKN', 'XHKG-N', 'HKE', 'XHKG-E'];
  return HKMList.some(a => new RegExp(a).test(code));
}
/*
检查是否港股(不含港股指数)
 */
export const isHKMHKG = code => {
  const HKMList = ['HKM', 'HKG'];
  return HKMList.some(a => new RegExp(a).test(code));
}
/*
检查是否外汇
 */
export const checkExchange = code => {
  const exchangeList = ['LWORK','XBFX','FXBK','FXCFES','CFES'];
  return exchangeList.some(a => new RegExp(a).test(code));
}

/**
 * 检查是否外汇市场（全）
 * @param {String} code 代码
 * @param {String} type 外汇市场类型
 */
export const checkForex = (code, type='wh_zq_hb_hj') => {
  let _data = [];
  const whForex = ['FXCFES', 'CFES', 'FXBK', 'XBFX']; // 外汇
  const zqForex = ['BONDCFES', 'XBBD']; // 债券
  const hbForex = ['MMCFES']; // 货币
  const hjForex = ['AUCFES', 'XBAU']; // 黄金
  const data = type.split('_').map(item=>item + 'Forex')
  const forexAll = {'whForex': whForex, 'zqForex': zqForex, 'hbForex': hbForex, 'hjForex': hjForex}
  data.forEach(d => {
    const last = forexAll[d]
    _data = [..._data, ...last]
  })
  return _data.some(a=>new RegExp(a).test(code))
}
/*
检查是否板块
 */
export const checkBlock = (code, hqType) => {
  const blockList = ['XBHS', 'XBHK'];
  return blockList.some(a => new RegExp(a).test(code));
}
/*
检查是否指数
 */
export const checkMRI = (code, hqType) => {
  const mriList = ['MRI'];
  return mriList.some(a => new RegExp('^[^\.]+?\.' + a).test(hqType));
}
export const numberFormat = (number, ratioFixed = 2) => {
  if (!isValidNumber(number) || !isValidNumber(ratioFixed)) {
    throw new Error(`${number} or ${ratioFixed} is not a valid number`);
  }
  if(Math.abs(number) > 1000000000000){
    return (Math.abs(number) / 1000000000000).toFixed(ratioFixed) + 'trillion';
  }  else if (number > 100000000) {
    return number > 0 ? (number / 100000000).toFixed(ratioFixed) + 'hundred million': (number / 100000000).toFixed(ratioFixed) + 'hundred million'
  } else if (Math.abs(number) >= 10000) {
    return number > 0?(number / 10000).toFixed(ratioFixed) + 'ten thousand' :(number / 10000).toFixed(ratioFixed)+'ten thousand'
  } else {
    return number.toFixed(0);
  }
}
export const zeroBug = ({self,refer_val,type = 1,radioFix = 2,symbol})=>{
  //refer_val第二参照，自己为0并且需要判断它是否为0是需要传
  //1:收盘为0，自己是0显示--，,
  //2：自己是0，收盘不为0=》type==1涨跌幅，涨跌额，振幅 展示0.00，type==2持仓量、成交量、成交额展示0//3涨跌额0.000
  let text = self;
  if(self===0||self==null||isNaN(self)){//!self
    if(refer_val == 0){
      text = '--'
    }else {
      const last = Math.pow(10,radioFix).toString().slice(1)
      if(symbol == 1){
        console.log(text)
      }
    if(type == 3){
      text = '0'+(radioFix==0?'':'.')+last
    }else {
      const a = '0.'+(last.length<=2?'00':last)
      text=type == 1?a:'0'
    }
    }
    return text
  }
  if(typeof text == 'string'){
    return text
  }
  if(typeof text == 'number'){
    text = type == 2? numberFormat(text,radioFix):text.toFixed(radioFix)
  }
  // return numberFormat(text,radioFix)
  return text
}

/*
将成交量转换成手的规则
return: true:需要除以share_per_hand；false:不需转换；100:需要除以100
*/
export const ifTransVolToHand = (code) => {
  const handList = ['XSHG', 'SS', 'XSHE', 'SZ', 'XSB', 'NEEQ']
  const hundredList = ['XBHS', 'CNI', 'GZZS', 'ZZZS', 'CSI']
  if (handList.some(a=>new RegExp('^[^\.]+?\.' + a).test(code))) {
    return true
  } else if (hundredList.some(a=>new RegExp('^[^\.]+?\.' + a).test(code))) {
    return 100
  } else {
    return false
  }
}

/*
获取保留几位小数点
 */
export const getToFixed = (code, type = '') => {
  let point = 2;
  const three = ['price','upDown']
  const dType =  three.some( a => a == type );
  if(checkHKM(code)){
    if(dType){
      if(checkMRI(code)){
        point = 2
      }
      point = 3
    }else {
      point = 2
    }
    return point
  }
  if(checkExchange(code)){
    return point = 4
  }
  return point
}
/**
 * 根据股票代码，获取辅视图黑名单
 */
export const checkFootBlackList = ({code, period, hqTypeCode, tradeStatus}) => {
  const {
    AMOUNT_KEY,
    MACD_KEY,
    BOLL_KEY,
    PSY_KEY,
    LIANGBI_KEY,
    RSI_KEY,
    OBV_KEY,
    DMI_KEY,
    WR_KEY,
    VR_KEY,
    DMA_KEY,
    KDJ_KEY,
    ENE_KEY,
    ELECTRIC_KEY,
    FUNDFLOW_KEY,
    FUNDFLOWDIR_KEY,
  } = KEY_MAP;
  const blackList = new Set();
  // 默认不显示晓鲸电波
  blackList.add(ELECTRIC_KEY);
  if (checkBlock(code)) {
    // 板块不显示资金博弈
    blackList.add(FUNDFLOW_KEY);
    if (checkHKM(code)) {
      // 港股板块不显示资金流向
      blackList.add(FUNDFLOWDIR_KEY);
    }
  } else if (checkMRI(code, hqTypeCode)) {
    // 指数不显示资金博弈资金流向
    blackList.add(FUNDFLOW_KEY);
    blackList.add(FUNDFLOWDIR_KEY);
    // if (checkHKM(code)) {
    //   // 港股指数不显示成交量
    //   if (period !== TREND_FIVE) {
    //     blackList.add(AMOUNT_KEY);
    //   }
    // }
  } else {
    if (checkSS(code)) {
      // 个股不显示资金流向
      blackList.add(FUNDFLOWDIR_KEY);
      // 个股支持电波
      blackList.delete(ELECTRIC_KEY);
    } else {
      // 港美个股，期货外汇不显示资金博弈资金流向
      blackList.add(FUNDFLOW_KEY);
      blackList.add(FUNDFLOWDIR_KEY);
      if (checkExchange(code)) {
        // 外汇不显示成交量
        blackList.add(AMOUNT_KEY);
      }
    }
  }
  return Array.from(blackList);
};
/**
 * 根据股票代码，获取主视图黑名单
 */
export const checkMainBlackList = ({code, hqType}) => {
  const {
    TREND_KEY,
    MA_KEY,
    JZ_KEY,
    KD_KEY,
    BOLL_KEY,
  } = KEY_MAP;
  const blackList = new Set();
  // 默认不显示鲸奇9转
  blackList.add(JZ_KEY);
  if (checkSS(code)) {
    blackList.delete(JZ_KEY);
  }
  return Array.from(blackList);
};
/**
 * 上海/深圳A,B股，深圳创业板，深圳中小板
 * 检查是否需要展示资金博弈
 */
export const checkTrademinGrp = (hqType) => {
  return ['ESA.M', 'ESA.GEM', 'ESA.SMSE', 'XBHS', 'ESB'].some(a => new RegExp(a).test(hqType));
}
/*
检查是否需要展示均线
 */
export const checkAvg = (code, hqType) => {
  if (!/XBHS/ig.test(hqType) && !/HK/ig.test(hqType)) {
    const SSAvg = ['000001', '000002', '000003', '000300', '000905', '000016', '1A0001', '1A0002', '1A0003'];
    const SZAvg = ['399001', '399002', '399003', '399005', '399006', '2A01', '2A02', '2A03'];
    // 新增国证指数，不展示均线
    if (/^CNI/i.test(hqType)) {
      return false
    }
    return !/\.MRI$/i.test(hqType)
      || SSAvg.findIndex(a => new RegExp(a + '\s?' + '\.SS$').test(code)) > -1
      || SZAvg.findIndex(a => new RegExp(a + '\s?' + '\.SZ$').test(code)) > -1;
  }
  // 港股指数仅恒生指数展示均线
  if(/^HSI.HKI/ig.test(code)||/^HSI.XHKG-I/ig.test(code)){
    return true
  }
  return false;
}
/*
* 检查是否需要均线 
* 港股指数下只显示恒生指数，其余一律显示
*/
// export const checkAvg = (code, hqType) => {
//   if (/HKI/ig.test(hqType) || /XHKG-I/ig.test(hqType)) {
//     if (/^HSI.HKI/ig.test(code)||/^HSI.XHKG-I/ig.test(code)) {
//       return true
//     } else {
//       return false
//     }
//   }
//   return true
// }
/*
* 是否为重要指数
*/
export const isImportantIndex = (code) => {
  const SSIndex = ['000001', '000002', '000003', '000300', '000905', '000016', '1A0001', '1A0002', '1A0003'];
  const SZIndex = ['399001', '399002', '399003', '399005', '399006', '2A01', '2A02', '2A03'];
  return SSIndex.findIndex(a => new RegExp(a + '\s?' + '\.SS$').test(code)) > -1
  || SZIndex.findIndex(a => new RegExp(a + '\s?' + '\.SZ$').test(code)) > -1
}
/**
 * [transformAmerican 美股转换时差]
 * @param  {[type]} time [时间，如0930, int型]
 * @return {[type]}      [description]
 */
const padStart = (val, fixed = 2, fill = '0') => {
  return val.toString().padStart(fixed, fill);
}
/**
 * 美股夏令时区间
 */
const winterZone = (() => {
  const date = new Date();
  const year = date.getFullYear();
  const t1 = new Date(year + '/03/01');
  const t2 = new Date(year + '/11/01');
  const week1 = t1.getDay();
  const week2 = t2.getDay();
  const day1 = 8 + (7 - week1) % 7;
  const day2 = 1 + (7 - week2) % 7;
  const start = new Date(year, 2, day1, 2, 0, 0);
  const end = new Date(year, 10, day2, 2, 0, 0);
  return {start, end};
})();
export const isAmericanWinter = (date) => {
  const {start, end} = winterZone;
  return !(date > start && date < end)
};
export const transformAmerican = ({time, format = 'yyyy/MM/dd hh:mm'}) => {
  if (/^\d{3,4}$/.test(time)) {
    const date = new Date();
    const AmericanTimeDis = isAmericanWinter(date) ? 13 : 12;
    const minute = padStart(time % 100);
    const hour = padStart((~~(time / 100) + AmericanTimeDis) % 24);
    return hour + '' + minute;
  } else {
    time = new Date(time);
    const AmericanTimeDis = isAmericanWinter(time) ? 13 : 12;
    time = new Date(time.getTime() + AmericanTimeDis * 3600000);
    return timeFormat(time, format);
  }
};
export const timeFormat = (time, format) => {
  const o = {
    'M+' : () => time.getMonth() + 1,
    'd+' : () => time.getDate(),
    'h+' : () => time.getHours(),
    'm+' : () => time.getMinutes(),
    's+' : () => time.getSeconds(),
    'q+' : () => Math.floor((time.getMonth() + 3) / 3),
    'S'  : () => time.getMilliseconds()
  };
  if (/(y+)/.test(format))
    format = format.replace(RegExp.$1, (time.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (const k in o) {
    if(new RegExp("("+ k +")").test(format)) {
      const rst = o[k]();
      format = format.replace(RegExp.$1, (RegExp.$1.length === 1) ? (rst) : (('00'+ rst).substr((''+ rst).length)));
    }
  }
  return format;
}

/**
 * 根据timeStamp，isAmerican
 * 计算时差并返回相应格式的字符串
 */
export const transformTime = ({code, timeStamp, format = 'yyyy/MM/dd', isAmerican}) => {
  timeStamp = timeStamp || timeFormat(new Date(), 'yyyyMMdd');
  return timeStamp.toString().replace(/(\d{4})(\d{2})(\d{2})(\d{2})?(\d{2})?\d*/, (...args) => {
    if (!isAmerican) {
      let rst = args[1] + '/' + args[2] + '/' + args[3];
      if (args[4] && args[5]) {
        rst += ' ' + args[4] + ':' + args[5];
      }
      return rst;
    } else {
      let time = args[1] + '/' + args[2] + '/' + args[3];
      if (args[4] && args[5]) {
        time += ' ' + args[4] + ':' + args[5];
        return transformAmerican({time, format: 'yyyy/MM/dd hh:mm'});
      }
      return transformAmerican({time, format});
    }
  });
}

/**
 * 设置分时图数据精确度
 */
export const checkNumFixed = (code, hqType) => {
  let ratioFixed = 2;
  if (checkExchange(code)) {
    // 外汇保留4位
    ratioFixed = 4;
  } else if (checkAmerican(code) || checkHKM(code)) {
    // 美股、港股保留三位小数
    ratioFixed = 3;
  } else if (checkFutures(code)) {
    if (code.indexOf("CCFX") >= 0) {
      if (code.indexOf("T") === 0) {
        // 中金所控制，国债保留三位小数
        ratioFixed = 3;
      } else {
        // 金融期货保留1位小数，例如IC,IF开头的期货
        ratioFixed = 1;
      }
    } else {
      //其他期货取整
      ratioFixed = 0;
    }
  } else if (checkSS(code)) {
    if (/XSHE\.EM\.SF/.test(hqType)) {
      // 基金(XSHE.EM.SF)保留三位小数
      ratioFixed = 3;
    } else {
      // 沪深个股保留两位
      if (/ESB$/.test(hqType)) {
        // 沪深B股保留三位
        ratioFixed = 3;
      } else {
        ratioFixed = 2;
      }
    }
  }
  return ratioFixed;
}
/*
返回两个时间点之间的分钟数
 */
export const getTimeStamp = (openTime, closeTime) => {
  let t1 = ~~(openTime / 100) * 60 + openTime % 100;
  let t2 = ~~(closeTime / 100) * 60 + closeTime % 100;
  return t2 - t1;
}
/*
获取fields索引
 */
export const getIndex = (fields, key) => {
  return fields.findIndex(a => a === key);
}
/*
字符串转换为时间格式
0040 -> 00:40
 */
export const getTime = timeStr => {
  timeStr = timeStr % 2400;
  return padStart(timeStr, 4).replace(/(\w{2})(\w{2})/ig, '$1:$2')
}
/**
 *
 */
export const isKline = period => {
  return [
    KLINE_ONEMIN,
    KLINE_FIVEMIN,
    KLINE_FIFMIN,
    KLINE_THIMIN,
    KLINE_SIXMIN,
    KLINE_ONEDAY,
    KLINE_ONEWEEK,
    KLINE_ONEMONTH,
    KLINE_ONEYEAR
  ].findIndex(a => a === period) > -1;
}
/**
 * 埋点装饰器
 * before 在实例方法之前触发
 * after 在实例方法之后触发
 */
const dectorator = function({eventId, fn, args}) {
  let {code, log} = this.store.state;
  if (!log) return;
  let rst = true;
  if (Util.isFunction(fn)) {
    const {isTrigger = true, event} = fn.apply(this, args);
    rst = isTrigger;
    if (Util.isString(event)) {
      eventId = event;
    }
  }
  if (rst) {
    log({eventId, other: {stockCode: code}});
    log.apply(this);
  }
}
export const beforeLog = ({...params}) => {
  return (target, name, descriptor) => {
    const method = descriptor.value;
    descriptor.value = function(...args) {
      dectorator.call(this, {...params, args});
      method.apply(this, args);
    }
    return descriptor;
  }
}
export const afterLog = ({...params}) => {
  return (target, name, descriptor) => {
    const method = descriptor.value;
    descriptor.value = async function(...args) {
      await method.apply(this, args);
      dectorator.call(this, {...params, args});
    }
    return descriptor;
  }
}
/*
字体颜色对比
*/
export const fontColor = (current, compare) => {
  // [红，绿，灰]
  let color = ['#ef4342', '#2ab447', "#333"]
  if (current === 0) {
    return color[2]
  }else if(current > compare) {
    return color[0]
  } else if(current < compare) {
    return color[1]
  } else {
    return color[2]
  }
}
/*
是否其中之一
*/ 
export const isOneOf = (list, compare) => {
  return list.some(item => compare.includes(item))
}
